module.exports = __webpack_public_path__ + "img/newLogo.02f34f9b.jpg";